import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import App from "./App.vue";
import Auth from '@/fstore/auth';
import router from "./router";
import store from "./store";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import "./misc/filters";
import './misc/breakpoints';
import "bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import CKEditor from '@ckeditor/ckeditor5-vue';

//fontawesome icons
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { firestorePlugin } from 'vuefire'

import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

Vue.use(firestorePlugin);

require('dotenv').config();

library.add(fas, fab);

//gaxios defaults
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueAxios, axios);
Vue.use(CKEditor);

Vue.config.productionTip = false;
Auth.ref.onAuthStateChanged(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount("#app");
});
